module.exports = __webpack_public_path__ + "static/icon-6cc40f977e23313cccbcb76f584eb914.png";